export default __webpack_public_path__ + "static/media/logo-atpar.e2d64631.png";